import React from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";

const AnomalyDashboard = () => {
  return (
    <PageScaffold title="Anomaly Dashboard" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        <iframe
          src="https://garaaz.retool.com/apps/Anomaly%20Dashboard"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Anomaly Dashboard"
        />
      </Box>
    </PageScaffold>
  );
};

export default AnomalyDashboard;
